module.exports = __webpack_public_path__ + "static/Spain-Step2-13b03897a8a8ff7eac4d3af1988b44b3.png";